<template>
  <div class="application">
    <div class="application-task">
      <div v-for="(item, index) in list" :key="index" class="task-one"
        :class="item.process ? 'finished' : index === 4 ? 'ing' : ''">
        {{ index + 1 }}.{{ item.name }}
        <div class="box">
          <div v-if="!item.process"></div>
          <i v-else class="icon iconfont icon-duigou" style="color:#fff;"></i>
        </div>
      </div>
      <div class="line"></div>
    </div>
    <div class="application-header">
      <p>参展申请</p>
      <span></span>
      <p>确认信息</p>
    </div>

    <div class="application-content">
      <div class="content-title">
        <span class="l">基本信息</span>
        <span class="r" @click="editBasic">修改</span>
      </div>

      <div class="content-com" v-if="basicInfo">
        <span v-if="basicInfo.companyName">公司名称：</span>
        <p v-if="basicInfo.companyName">{{ basicInfo.companyName }}</p>
        <span v-if="basicInfo.companyNameEn">英文名称：</span>
        <p v-if="basicInfo.companyNameEn">{{ basicInfo.companyNameEn }}</p>
        <span v-if="basicInfo.companyNameShort">品牌名称：</span>
        <p v-if="basicInfo.companyNameShort">{{ basicInfo.companyNameShort }}</p>
        <p v-if="basicInfo.unifiedCode" style="width:100%;">统一社会信用代码：{{ basicInfo.unifiedCode }}</p>
        <span>公司地址：</span>
        <p>
          <span v-if="basicInfo.country">{{ basicInfo.country }}</span>
          <span v-if="basicInfo.province">/{{ basicInfo.province }}</span>
          <span v-if="basicInfo.city">/{{ basicInfo.city }}</span>
          <span v-if="basicInfo.county">/{{ basicInfo.county }}</span>
        </p>
        <span>详细地址：</span>
        <p> {{ basicInfo.address }} </p>
        <p v-if="basicInfo.telephone" style="width:100%;">公司座机：{{ basicInfo.telephone }}</p>
        <span v-if="basicInfo.website">公司网址：</span>
        <p v-if="basicInfo.website">{{ basicInfo.website }}</p>
        <p v-if="basicInfo.typeAsset" style="width:100%;">资产类型：{{ basicInfo.typeAsset }}</p>
        <p v-if="basicInfo.typeBusiness" style="width:100%;">企业经营类型：{{ basicInfo.typeBusiness }}</p>
      </div>

      <div class="content-title2">
        <div>
          <span class="l">展会联系人</span>
          <span class="r" @click="editBasic">修改</span>
        </div>
        <div>
          <span class="l">市场部负责人</span>
          <span class="r" @click="editBasic">修改</span>
        </div>
      </div>

      <div class="content-link" v-if="basicInfo">
        <div>
          <span v-if="basicInfo.linkMan">姓名：</span>
          <p v-if="basicInfo.linkMan">{{ basicInfo.linkMan }}</p>
          <span v-if="basicInfo.linkTitle">职务：</span>
          <p v-if="basicInfo.linkTitle">{{ basicInfo.linkTitle }}</p>
          <span v-if="basicInfo.linkMob">座机：</span>
          <p v-if="basicInfo.linkMob">{{ basicInfo.linkMob }}</p>
          <span v-if="basicInfo.linkQQ">QQ：</span>
          <p v-if="basicInfo.linkQQ">{{ basicInfo.linkQQ }}</p>
          <span v-if="basicInfo.linkEmail">邮箱：</span>
          <p v-if="basicInfo.linkEmail">{{ basicInfo.linkEmail }}</p>
        </div>
        <div>
          <span v-if="basicInfo.leader">姓名：</span>
          <p v-if="basicInfo.leader">{{ basicInfo.leader }}</p>
          <span v-if="basicInfo.leaderTitle">职务：</span>
          <p v-if="basicInfo.leaderTitle">{{ basicInfo.leaderTitle }}</p>
          <span v-if="basicInfo.leaderMob">座机：</span>
          <p v-if="basicInfo.leaderMob">{{ basicInfo.leaderMob }}</p>
          <span v-if="basicInfo.leaderQQ">QQ：</span>
          <p v-if="basicInfo.leaderQQ">{{ basicInfo.leaderQQ }}</p>
          <span v-if="basicInfo.leaderEmail">邮箱：</span>
          <p v-if="basicInfo.leaderEmail">{{ basicInfo.leaderEmail }}</p>
        </div>
      </div>

      <div class="content-title">
        <span class="l">开票信息</span>
        <span class="r" @click="editBasic">修改</span>
      </div>

      <div class="content-com" v-if="basicInfo">
        <template v-if="basicInfo.isInvoice === 'False' || basicInfo.isInvoice === 'false'">
          <span v-if="basicInfo.invoiceTitle">发票抬头：</span>
          <p v-if="basicInfo.invoiceTitle">{{ basicInfo.invoiceTitle }}</p>
          <span v-if="basicInfo.invoiceCode">税号：</span>
          <p v-if="basicInfo.invoiceCode">{{ basicInfo.invoiceCode }}</p>
          <span v-if="basicInfo.invoiceAddress">单位地址：</span>
          <p v-if="basicInfo.invoiceAddress">{{ basicInfo.invoiceAddress }}</p>
          <span v-if="basicInfo.invoiceTelephone">电话号码：</span>
          <p v-if="basicInfo.invoiceTelephone">{{ basicInfo.invoiceTelephone }}</p>
          <span v-if="basicInfo.invoiceBank">开户银行：</span>
          <p v-if="basicInfo.invoiceBank">{{ basicInfo.invoiceBank }}</p>
          <span v-if="basicInfo.invoiceBankAccount">银行账户：</span>
          <p v-if="basicInfo.invoiceBankAccount">{{ basicInfo.invoiceBankAccount }}</p>
          <span v-if="basicInfo.invoiceType">开票类型：</span>
          <p v-if="basicInfo.invoiceType">{{ basicInfo.invoiceType }}</p>
        </template>
        <div v-else style="text-align: center;width: 100%;line-height: 116px;">暂不填写</div>
      </div>

      <div class="content-title">
        <div>
          <span class="l" style="margin-right:60px;">展位信息</span>
          <span class="l" v-if="curType">展会：{{ curType.exhiName }}</span>
        </div>
        <span class="r" @click="editBooth">修改</span>
      </div>
      <!-- <pre class="info-side">
        {{ JSON.stringify(orderList, null, 4) }}
      </pre> -->

      <div class="content-exHall">
        <div style="padding-bottom: 20px;font-size: 18px;" v-if="orderList && orderList[0]">{{
          orderList[0].dePjNameGroupName }}</div>
        <div class="exHall" v-if="orderInfo && orderInfo.isAgent === '否'">
          <div class="exHall-one" v-for="(item, index) in orderList" :key="index">
            <div class="top">
              <p>{{ item.name }}</p>
              <p>单价：{{ item.unitPrice }} {{ item.monetaryUnit }}/ {{ item.unit }}</p>
              <p v-if="item.boothType === '光地'">面积：{{ item.area }}㎡</p>
              <p v-if="item.boothType === '标展' && curType">数量：{{ item.area / Number(curType.standstall) }}个</p>
            </div>
            <p class="subtotal">合计： <span>{{ item.totalPrice }}</span> {{ item.monetaryUnit }}</p>
          </div>
        </div>
      </div>

      <div class="content-title">
        <span class="l">会刊简介</span>
        <span class="r" @click="editIntroduction">修改</span>
      </div>
      <!-- <pre class="info-side">
        {{ JSON.stringify(orderInfo, null, 4) }}
      </pre> -->
      <div class="content-introduction" v-if="orderInfo">
        <p style="margin-bottom:10px;padding-left:30px;">
          公司或品牌名称：{{ orderInfo.catalogueName }}
        </p>
        <p style="margin-bottom:10px;padding-left:30px;">
          公司地址：{{ orderInfo.catalogueAddress }}
        </p>
        <p style="margin-bottom:10px;padding-left:30px;">
          固定电话：{{ orderInfo.catalogueTel }}
        </p>
        <p style="margin-bottom:10px;padding-left:30px;">
          公司邮箱：{{ orderInfo.catalogueEmail }}
        </p>
        <p style="margin-bottom:10px;padding-left:30px;">公司简介（中文）：</p>
        <p style="margin-bottom:10px;padding-left:30px;text-indent:2em" v-if="introduction" v-html="introduction"></p>
        <p style="margin-bottom:10px;padding-left:30px;">公司简介（英文）：</p>
        <p style="margin-bottom:10px;padding-left:30px;text-indent:2em" v-if="introductionEn" v-html="introductionEn"></p>
      </div>
    </div>

    <div class="application-btn">
      <Button type="primary" size="large" @click="finishApplyHandle" style="margin-right:20px;">提交并完成报名</Button>
    </div>
  </div>
</template>

<script>
import config from "@assets/config.json";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "application", // 参展申请
  data () {
    return {
      list: [],
      speenInfo: null,
      orderInfo: null,
      introduction: "",
      introductionEn: "",
      defaultList: [],
      uploadList: [],
      uploadName: "",
      basicInfo: null,
      orderList: [],
      orderPrice: 0,
      orderUnint: "",
      CMOprice: 0,
      Obligatory: 0,
      IsNeedActivity: "0",

      curType: null,
    };
  },
  components: {
  },
  computed: {
    ...mapGetters({
      formHeaders: "commonFill/getFormHeaders",
      uploadUrl: "commonFill/getUploadUrl",
    }),
    exhibitionId () {
      return this.$route.query.id;
    },
    applyCompanyId () {
      return this.$route.query.applyCompanyId;
    },
    applyCompanyOrderId () {
      return this.$route.query.applyCompanyOrderId;
    },
    groupId () {
      return this.$route.query.groupId;
    }
  },
  methods: {
    ...mapActions({
      getDePjNameGroup: "commonFill/getDePjNameGroup",
      getOrderDetail: "commonFill/getOrderDetail",
      getApplyFlow: "commonFill/getApplyFlow",
      getApplyFlowSpeed: "commonFill/getApplyFlowSpeed",
      getApplyCompanyBasic: "commonFill/getApplyCompanyBasic",
      finishApplyOperate: "commonFill/finishApplyOperate"
    }),
    async init () {
      // 流程
      let list = await this.getApplyFlow();
      this.list = list;
      let info = await this.getApplyFlowSpeed(this.applyCompanyId); 0
      if (info && info.info) {
        this.speenInfo = info.info;
        if (this.list && this.list.length > 0) {
          this.list.map(c => {
            if (this.speenInfo && this.speenInfo.speed >= c.speed) {
              c.process = true;
            }
          })
        }
      }
      // this.speenInfo不存在，即此轮流程已结束
      if (!this.speenInfo) {
        if (this.applyCompanyOrderId) {
          this.$router.push("/fill/join/basic?applyCompanyId=" + this.applyCompanyId + "&applyCompanyOrderId=" + this.applyCompanyOrderId);
        } else {
          this.$router.push("/fill/join/basic?applyCompanyId=" + this.applyCompanyId);
        }
      }

      // 基本信息
      let basicInfo = await this.getApplyCompanyBasic(this.applyCompanyId);
      this.basicInfo = basicInfo;

      // 订单信息
      let orderInfo = await this.getOrderDetail(this.applyCompanyOrderId);
      if (orderInfo && orderInfo.applyFileLink) {
        this.$router.push("/fill/join/finish?applyCompanyId=" + this.applyCompanyId + "&applyCompanyOrderId=" +
          this.applyCompanyOrderId);
      }
      if (orderInfo.catalogueAddress) {
        if (orderInfo.catalogueAddress.indexOf('/') === 0) {
          orderInfo.catalogueAddress.replace('/', '')
        }
      }
      this.orderInfo = orderInfo;
      this.getType(orderInfo);
      this.introduction = this.enter(orderInfo.introduction) || "";
      this.introductionEn = this.enter(orderInfo.introductionEn) || "";
      if (this.orderInfo && this.orderInfo.applyBoothOrderList.length > 0) {
        let allP = 0;
        this.orderInfo.applyBoothOrderList.map(c => {
          c.orderType = "booth";
          this.orderList.push(c);
          allP += c.totalPrice;
          this.orderUnint = c.monetaryUnit;
        })
        this.orderPrice += allP;
      }
      if (this.orderInfo && this.orderInfo.applyOtherOrderList.length > 0) {
        this.orderInfo.applyOtherOrderList.map(c => {
          if (c.dePjNameGroupName != '固定费用') {
            c.orderType = "other";
            this.orderList.push(c);
            this.orderPrice += c.totalPrice;
            this.CMOprice += c.totalPrice;
          }
          else {
            this.orderList.push(c);
            this.orderPrice += c.totalPrice;
            this.Obligatory += c.totalPrice;
          }
        })
      }
      console.log("订单信息：", this.orderInfo);
    },
    async getType (info) {
      let list = await this.getDePjNameGroup({
        IsBoothGroup: "是", ExhibitionId: this.exhibitionId, TypeLanguage: "中文",
      });
      if (!list) return;
      list.forEach(c => {
        if (info.applyBoothOrderList[0].dePjNameGroupId === c.id) {
          c.dePjNameList.forEach(v => {
            if (v.pjCode === info.applyBoothOrderList[0].pjCode) {
              this.curType = v
              console.log('当前状态的展位类型:', v);
            }
          });
        }
      });
    },
    enter (str) {
      let str1 = str.replace(/\n/g, "<br/>");
      return str1;
    },
    handleSuccess (res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList.push({
          name: this.uploadName,
          url: res.list[0],
          status: "finished"
        });
      } else {
        this.uploadName = "";
      }
    },
    handleFormatError (file) {
      this.uploadName = "";
      this.$Notice.warning({
        title: "文件格式是不正确的",
        desc: "请上传图片或者pdf文件"
      });
    },
    handleMaxSize (file) {
      this.uploadName = "";
      this.$Notice.warning({
        title: "文件大小超过限制",
        desc: "请上传小于50M的文件"
      });
    },
    handleBeforeUpload (e) {
      this.uploadName = e.name;
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Notice.warning({
          title: `最多上传${limitNum}个文件`
        });
      }
      return check;
    },
    handleRemoveByArr (file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    async finishApplyHandle () {
      let req = {
        Id: this.applyCompanyOrderId,
        ApplyFileLink: "finished",
        IsMultipleEmail: false,
      }
      let bool = await this.finishApplyOperate(req);
      if (bool && bool.successed) {
        this.$Message.success("提交成功！");
        this.$router.push("/fill/join/finish?applyCompanyId=" + this.applyCompanyId + "&applyCompanyOrderId=" + this.applyCompanyOrderId);
      }
    },
    downloadPdf () {
      window.open(`${config.api.reqApi}/Pdf/Index?orderId=` + this.applyCompanyOrderId, "_blank");
    },
    editBasic () {
      this.$router.push("/fill/join/basic?applyCompanyId=" + this.applyCompanyId + "&applyCompanyOrderId=" + this.applyCompanyOrderId);
    },
    editBooth () {
      if (this.groupId) {
        this.$router.push("/fill/join/order?id=" + this.exhibitionId + "&applyCompanyId=" + this.applyCompanyId + "&applyCompanyOrderId=" + this.applyCompanyOrderId + "&groupId=" + this.groupId);
      } else {
        this.$router.push("/fill/join/order?id=" + this.exhibitionId + "&applyCompanyId=" + this.applyCompanyId + "&applyCompanyOrderId=" + this.applyCompanyOrderId);
      }
    },
    editIntroduction () {
      if (this.groupId) {
        this.$router.push("/fill/join/catalogue?id=" + this.exhibitionId + "&applyCompanyId=" + this.applyCompanyId + "&applyCompanyOrderId=" + this.applyCompanyOrderId + "&groupId=" + this.groupId);
      } else {
        this.$router.push("/fill/join/catalogue?id=" + this.exhibitionId + "&applyCompanyId=" + this.applyCompanyId + "&applyCompanyOrderId=" + this.applyCompanyOrderId);
      }
    }
  },
  created () {
    this.init();
  }
};
</script>

<style scoped lang='scss'>
.application {
  &-task {
    width: 100%;
    margin: 20px 0 50px;
    padding: 0 80px;
    display: flex;
    justify-content: space-between;
    color: #666;
    position: relative;

    .task-one {
      display: flex;
      flex-direction: column;
      align-items: center;
      z-index: 2;

      .box {
        width: 20px;
        height: 20px;
        background-color: #fff;
        box-shadow: 0px 2px 5px 0px rgba(1, 53, 97, 0.5);
        border-radius: 50%;
        margin-top: 10px;

        div {
          width: 14px;
          height: 14px;
          background-color: #8ba5bc;
          border-radius: 50%;
          margin: 3px auto 0;
        }
      }
    }

    .line {
      height: 8px;
      background-color: #d7dee4;
      position: absolute;
      width: 998px;
      left: 108px;
      top: 37px;
      z-index: 1;
    }

    .ing {
      color: rgba(0, 161, 233, 1);

      .box {
        div {
          background-color: rgba(0, 161, 233, 1);
        }
      }
    }

    .finished {
      color: rgba(0, 161, 233, 1);

      .box {
        background-color: rgba(0, 161, 233, 1);
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  &-header {
    width: 100%;
    height: 64px;
    background-color: rgba(0, 161, 233, 1);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      line-height: 64px;
      font-size: 20px;
    }

    span {
      width: 30px;
      height: 1px;
      background-color: #fff;
      margin: 0 15px;
    }
  }

  &-content {
    .content-title {
      width: 100%;
      height: 48px;
      background-color: #ededed;
      padding: 0 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .l {
        font-size: 18px;
        color: #333;
      }

      .r {
        color: #1890ff;
        cursor: pointer;
      }
    }

    .content-com {
      padding: 20px 60px;
      background-color: #fff;
      display: flex;
      flex-wrap: wrap;
      color: #333;

      p {
        width: calc(100% - 100px);
        margin-bottom: 5px;
      }
    }

    .content-title2 {
      width: 100%;
      height: 48px;
      background-color: #ededed;
      display: flex;

      div {
        width: 50%;
        height: 100%;
        padding: 0 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .l {
          font-size: 18px;
          color: #333;
        }

        .r {
          color: #1890ff;
          cursor: pointer;
        }
      }
    }

    .content-link {
      display: flex;
      background-color: #fff;

      div {
        width: 50%;
        padding: 20px 20px 20px 61px;
        display: flex;
        flex-wrap: wrap;

        p {
          width: calc(100% - 50px);
          margin-bottom: 5px;
        }
      }
    }

    .content-exHall {
      padding: 30px 0 30px 60px;
      background-color: #fff;
      color: #333;

      .exHall {
        display: flex;
        flex-wrap: wrap;

        &-one {
          width: 360px;
          border: 1px solid #d9d9d9;
          margin-right: 30px;
          margin-bottom: 20px;

          .top {
            padding: 20px 20px 5px 20px;
            border-bottom: 1px solid #d9d9d9;
            line-height: 1;
            height: 190px;

            p {
              margin-bottom: 15px;
              font-size: 18px;
            }

            .remark {
              font-size: 14px;
            }
          }

          .subtotal {
            background-color: #f5f5f5;
            line-height: 46px;
            padding: 0 20px;
            text-align: right;
            font-size: 16px;

            span {
              color: #ed4014;
              font-size: 20px;
              font-weight: 600;
            }
          }
        }

        .line {
          width: calc(100% - 30px);
          height: 1px;
          background-color: #d9d9d9;
        }

        .totalPrice {
          font-size: 18px;
          margin-top: 20px;
          width: 100%;
          padding-right: 30px;
        }
      }
    }

    .content-introduction {
      padding: 20px 30px;
      background-color: #fff;
      color: #333;

      p {
        word-break: break-all;
      }
    }

    .content-table {
      background-color: #fff;
      padding: 30px;

      .f {
        width: 180px;
        height: 36px;
        background-color: #f5f5f5;
        line-height: 36px;
        text-align: center;
        margin: 0 auto 10px;
        cursor: pointer;
      }
    }
  }

  .license-img {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;

    &-list {
      padding: 0 10px;
      background-color: #fff;
      display: flex;
      align-items: center;

      span {
        color: #1890ff;
        cursor: pointer;
      }

      .line {
        width: 1px;
        height: 24px;
        background-color: #e6e6e6;
        margin: 0 6px;
      }
    }
  }

  &-btn {
    margin-top: 50px;
    padding-bottom: 80px;
    text-align: center;

    button {
      width: 200px;
      height: 48px;
      background-color: rgba(0, 161, 233, 1);
      font-size: 16px;
      border-color: rgba(0, 161, 233, 1);
    }
  }
}
</style>
